import { Text } from '@chakra-ui/react';
import React from 'react';
import { DataViewerProps } from 'react-spreadsheet';

type CellTextProps = { value: string; classNames?: string };
const CellText = ({ value, classNames = '' }: CellTextProps) => {
  return (
    <Text w="24" className={`Spreadsheet__data-viewer ${classNames}`}>
      {value}
    </Text>
  );
};

const NAME_ERROR = '#NAME?';

export const CustomDataViewer = ({ cell, evaluatedCell }: DataViewerProps) => {
  let value = evaluatedCell?.value ?? cell?.value;

  /**
   * Since we're allowing the ability to utilize custom variables from inputConfig
   * (e.g., can use a variable from Athena queries or intermediate fields),
   * this introduces variables that Excel normally isn't aware of, resulting in "#NAME?" error.
   * For now, manually overriding "#NAME?" errors so user can still see and edit the raw input
   *
   * In future, can look to see if we can inject our own accepted variables to remedy this
   */
  if (value === NAME_ERROR) {
    value = cell?.value;
  }
  const valueType = typeof value;

  /**
   * That seems to be an underlying issue with "fast-formula-parser", which is the library
   * "react-spreadsheet" utilizes to help with managing formulas. Errors seem to get thrown
   * as "#REF!" objects that can't be rendered, so just defaulting to "null" for now.
   * https://github.com/iddan/react-spreadsheet/issues/352
   *
   * This seemingly still works fine so just overriding for now, but should revisit if
   * there are any unwarranted side-effects or behaviors
   */
  if (valueType === 'object') {
    return null;
  }

  if (valueType === 'boolean') {
    return (
      <CellText
        value={value ? 'TRUE' : 'FALSE'}
        classNames="Spreadsheet__data-viewer--boolean"
      />
    );
  }

  return <CellText value={value} />;
};
